import { NoPage } from "@/Icons/NoPage";
import { Translate } from "@/translations";

export const NotFound = () => {
  return (
    <div className="bg-grey1 fixed top-0 right-0 bottom-0 left-0 z-30 flex items-center justify-center">
      <h1 className="font-signifier w-[920px] text-center text-3xl">
        <div className="mb-5 flex justify-center">
          <NoPage width={130} />
        </div>
        <div className="mb-3 font-semibold">
          <Translate i18nKey={"errors:notFound"} />
        </div>
        <Translate
          i18nKey={"errors:notFoundDescription"}
          components={[
            // Anchor content is added by the translation
            // eslint-disable-next-line jsx-a11y/anchor-has-content
            <a href="mailto:support@carrot.tech" className="underline" />,
          ]}
        />
      </h1>
    </div>
  );
};

export default NotFound;
